import React from 'react';
import PropTypes from 'prop-types';

import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

const ValidatedSelectField = ({
	name,
	label,
	formData,
	errors,
	options,
	handleInputChange,
	handleInputBlur,
	...props
}) => {
	return (
		<TextField
			select
			fullWidth
			name={name}
			label={label}
			value={formData[name]}
			error={!!errors[name]}
			helperText={errors[name] || ''}
			onChange={(e) => handleInputChange(name, e.target.value)}
			onBlur={(e) => handleInputBlur(name, e.target.value)}
			inputProps={{ autoComplete: 'off' }}
			{...props}
		>
			{options.map((option) => {
				const value = option.abbreviation || option.value;
				const label = option.name || option.label;

				if (option.disabled) {
					return (
						<MenuItem
							key={value}
							value={value}
							disabled
							sx={{
								display: 'flex',
								justifyContent: 'space-between'
							}}
						>
							<Typography component='span' sx={{ color: 'text.disabled' }}>
								{label}
							</Typography>

							<Typography
								component='span'
								variant='caption'
								sx={{
									color: 'text.disabled',

									ml: 1
								}}
							>
								(Unavailable for {option.abbreviation} residents)
							</Typography>
						</MenuItem>
					);
				}

				return (
					<MenuItem key={value} value={value}>
						{option.name || option.label}
					</MenuItem>
				);
			})}
		</TextField>
	);
};

ValidatedSelectField.propTypes = {
	name: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	formData: PropTypes.object.isRequired,
	errors: PropTypes.object.isRequired,
	options: PropTypes.array.isRequired,
	handleInputChange: PropTypes.func.isRequired,
	handleInputBlur: PropTypes.func.isRequired
};

export default ValidatedSelectField;
